import React from 'react';

import WebshopsHero from '../components/WebshopsHero/WebshopsHero';
import WebshopPackages from '../components/WebshopPackages/WebshopPackages';
import WhatToExpect from '../components/WhatToExpect/WhatToExpect';
import WebshopProcess from '../components/WebshopProcess/WebshopProcess';
import WebshopTestimonials from '../components/WebshopTestimonials/WebshopTestimonials';
import WebshopPortfolio from '../components/WebshopPortfolio/WebshopPortfolio';
import ModernWhyChooseUs from '../components/ModernWhyChooseUs/ModernWhyChooseUs';

const WebshopsPage = () => {

  return (
    <>
      <WebshopsHero />
      <WebshopPackages />
      <WhatToExpect />
      <WebshopProcess />
      <WebshopPortfolio />
      {/* <WebshopTestimonials /> */}
      <ModernWhyChooseUs />
    </>
  );
};

export default WebshopsPage;
